'use client';
import BoxArrowInRight from '@/components/icons/Navigation/BoxArrowInRight';
import People from '@/components/icons/People';
import Person from '@/components/icons/Person';
import Setting from '@/components/icons/Setting';
import Work from '@/components/icons/Work';
import useBrand from '@/hooks/useBrand';
import useNavigate from '@/hooks/useNavigate';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import navbarStyles from '@/styles/navbar.module.css';
import getEnv from '@/utils/env';
import { globalLogout } from '@/utils/LogoutUtils';
import { ReactNode } from 'react';
import styles from './style.module.scss';

export default function NavBar({ itemSelected }: { itemSelected: string }) {
  const navigate = useNavigate();
  const brand = useBrand().get();
  const openedNav = useAppSelector((state) => state.conf.openedNav);
  const items: { id: string; icon: ReactNode; label: string; url: string }[] = [
    {
      id: 'setting',
      icon: <Setting />,
      label: 'Paramétrer',
      url: 'societe/modifier',
    },
    {
      id: 'pdv',
      icon: <Work />,
      label: 'Numéros d’agrément',
      url: 'numero-agrement',
    },
    {
      id: 'employee',
      icon: <People />,
      label: 'Employés',
      url: 'employees',
    },
    {
      id: 'admin',
      icon: <Person />,
      label: 'Administrateurs',
      url: 'administrators',
    },
  ];

  function renderMenu() {
    if (getEnv().PROFIL === 'PARTENAIRE') {
      return [items[2], items[3]];
    } else return items;
  }
  const dispatch = useAppDispatch();
  return (
    <div className={`${navbarStyles.toggle}`}>
      <div
        className={`flex-column gap-xl ${styles['container']} ${
          openedNav ? styles['show-menu'] : ''
        }`}
      >
        {renderMenu().map((item, index) => (
          <div
            key={index}
            className={`flex-column gap-m ${styles['nav-item']} ${
              item.id == itemSelected && styles['selected']
            }`}
            onClick={() => navigate(`${item.url}`)}
          >
            {item.icon}
            <p>{item.label}</p>
          </div>
        ))}
        <div
          className={`flex-column gap-m ${styles['nav-item']} ${styles['logout-button']}`}
          onClick={() => globalLogout({ brand, navigate, dispatch })}
        >
          <BoxArrowInRight />
          <p>Déconnexion</p>
        </div>
      </div>
    </div>
  );
}
